import cx from 'classnames';
import React from 'react';
import { Heading, FormField, Input, Button } from 'wix-style-react';

import IndustryCustomInput from './IndustryCustomInput/IndustryCustomInput';
import s from './NamesPageHeader.scss';

class NamesPageDesktopHeaderV3 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      oneOfInputsIsBeingChanged: false
    };
  }
  handleBusinessIdeaChange = e => {
    const { onBusinessIdeaChange } = this.props;
    onBusinessIdeaChange(e.target.value);
    this.setState({
      oneOfInputsIsBeingChanged: true
    });
  };

  handleFormSubmit = e => {
    e.preventDefault();
    const { onSearch } = this.props;
    onSearch();
  };

  handleScroll = e => {
    e.stopPropagation();
  };

  handleIndustryTextChanged = industryText => {
    const { onIndustryChange } = this.props;
    onIndustryChange(industryText, industryText, true);
    this.setState({
      oneOfInputsIsBeingChanged: true
    });
  };

  handleIndustrySelected = industry => {
    const { onIndustryChange } = this.props;
    onIndustryChange(industry.id, industry.label, false);
  };

  onSearch = () => {
    const { onSearchNames } = this.props;
    this.setState({
      oneOfInputsIsBeingChanged: false
    });
    onSearchNames();
  };

  render() {
    const { t, businessIdea, industry, industriesFetcher } = this.props;
    const title = t('BNG_NAMES_LIST_HEADER_TITLE');
    const nameInputLabel = t('BNG_NAMES_LIST_EDIT_NAME_INPUT');
    const industryInputLabel = t('BNG_NAMES_LIST_EDIT_INDUSTRY_INPUT');
    const nameInputPlaceHolder = t('NAME_INPUT_PLACEHOLDER');
    const industryInputPlaceHolder = t('INDUSTRY_INPUT_PLACEHOLDER');
    const buttonText = t('NAMES_LIST_GENERATE_BUTTON');
    const { oneOfInputsIsBeingChanged } = this.state;

    return (
      <div className={cx(s.headerContainer)}>
        <div className={cx(s.wixLogoContainer, s.logoContainer)}>
          <div className={s.wixLogo} />
        </div>
        <div className={s.heading}>
          <Heading>{title}</Heading>
        </div>
        <div className={s.inputs}>
          <div className={s.form}>
            <FormField label={nameInputLabel}>
              <Input
                className={s.businessNameInput}
                maxLength={20}
                size="small"
                placeholder={nameInputPlaceHolder}
                value={businessIdea}
                onChange={this.handleBusinessIdeaChange}
              />
            </FormField>
          </div>
          <div className={s.form}>
            <FormField className={s.form} placeholder={industryInputPlaceHolder} label={industryInputLabel}>
              <IndustryCustomInput
                onIndustryTextChanged={this.handleIndustryTextChanged}
                onIndustrySelected={this.handleIndustrySelected}
                industryText={industry.industryText}
                industriesFetcher={industriesFetcher}
                placeHolderText={industryInputPlaceHolder}
                bng={true}
              />
            </FormField>
          </div>
          <div className={s.searchButton}>
            <Button
              fullWidth
              as="button"
              onClick={this.onSearch}
              size="small"
              priority={oneOfInputsIsBeingChanged ? 'primary' : 'secondary'}
              skin="dark"
            >
              {buttonText}
            </Button>
          </div>
        </div>
      </div>
    );
  }
}
export default NamesPageDesktopHeaderV3;
